import { useTranslate } from '@tolgee/react';
import styled from '@emotion/styled';
import Placeholder from './Placeholder';
import AideEmpty, { comingImage } from './Empty';

export interface ComingPlaceholderProps {}

export const Center = styled.div`
  flex: 1 0 0;
  height: 100%;
  padding: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ComingPlaceholder = (props: ComingPlaceholderProps) => {
  const { t } = useTranslate();
  return (
    <Placeholder>
      <Center>
        <AideEmpty>
          <img src={comingImage} alt="coming" />
          <p>{t('aide.即将上线')}</p>
        </AideEmpty>
      </Center>
    </Placeholder>
  );
};
export default ComingPlaceholder;
